import { reload_end_order_list } from "../http/EndOrderConn";
import { analyticeEvent } from "utils/Utils"


// 검색 레이어 조회 ( 검색어, 디테일 )
export function fn_getSearchView(rootStore) {
    return rootStore.endOrderStore.getEndOrderSearchView;
}
// 검색 레이어 열고 닫기 ( 검색어, 디테일 )
export function fn_setSearchView(rootStore, key, value) {
    fn_initSearchView(rootStore);
    rootStore.endOrderStore.setEndOrderSearchView(key, value);
}
// 검색 레이어 초기화 ( 검색어, 디테일 )
export function fn_initSearchView(rootStore) {
    rootStore.endOrderStore.initEndOrderSearchView();
}

// 검색 키값 조회
export function fn_getSearchKey(rootStore) {
    return rootStore.endOrderStore.getEndSearchKeyVal;
}
// 검색 키값 설정
export function fn_setSearchKey(rootStore, key, val) {
    rootStore.endOrderStore.setSearchKeyVal(key, val);
    fn_initSearchView(rootStore);
}
// 검색 키값 초기화
export function fn_initSearchKey(rootStore) {
    rootStore.endOrderStore.initSearchKeyVal();
}



// 검색 상세버튼 조회
export function fn_getDetailButtonView(rootStore) {
    return rootStore.endOrderStore.getDetailButtonView;
}
// 검색 상세버튼 설정
export function fn_setDetailButtonView(rootStore, key, val) {
    rootStore.endOrderStore.setDetailButtonView(key, val);
}
// 검색 상세버튼 초기화
export function fn_initDetailButtonView(rootStore) {
    rootStore.endOrderStore.initDetailButtonView();
}
// 이전 검색 조건으로 초기화
export function fn_setBeforeDetailUpdate(rootStore) {
    rootStore.endOrderStore.setBeforeDetailUpdate();
}

// 검색 값 조회
export function fn_getSearchVal(rootStore) {
    return rootStore.endOrderStore.getEndSearchVal;
}
// 검색 값 설정
export function fn_setSearchVal(rootStore, val) {
    rootStore.endOrderStore.setEndSearchVal(val);
}


// 검색 날짜설정 조회
export function fn_getDateTerm(rootStore) {
    return rootStore.endOrderStore.getEndDateTerm;
}
// 검색 날짜 버튼 설정
export function fn_setDateTerm(rootStore, key, val) {
    let termVal = fn_getDateTermVal(rootStore);
    rootStore.endOrderStore.setEndOrderPagingInfo("end_page_no", 1)
    if (key === "today") {
        rootStore.endOrderStore.setEndDateVal('start_val', termVal.today);
        rootStore.endOrderStore.setEndDateVal('end_val', termVal.today);
    } else if (key === "three") {
        rootStore.endOrderStore.setEndDateVal('start_val', termVal.three);
        rootStore.endOrderStore.setEndDateVal('end_val', termVal.today);
    } else if (key === "week") {
        rootStore.endOrderStore.setEndDateVal('start_val', termVal.week);
        rootStore.endOrderStore.setEndDateVal('end_val', termVal.today);
    }

    fn_initDateTerm(rootStore);
    rootStore.endOrderStore.setEndDateTerm(key, val);
}

// 검색 날짜 버튼 초기화
export function fn_initDateTerm(rootStore) {
    rootStore.endOrderStore.searchDateTerm();
}

// 버튼별 날짜 조회
export function fn_getDateTermVal(rootStore) {
    return rootStore.endOrderStore.getEndDateTermVal;
}


// 검색 시작일,종료일 조회
export function fn_getDateVal(rootStore) {
    return rootStore.endOrderStore.getEndDateVal;
}

// 검색 시작일,종료일 설정
export function fn_setDateVal(rootStore, key, val) {
    let startVal = rootStore.endOrderStore.getEndDateVal.start_val;
    let endVal = rootStore.endOrderStore.getEndDateVal.end_val;

    if (key === 'start_val') {
        if (endVal < val) {
            return;
        }
    } else if (key === 'end_val') {
        if (val < startVal) {
            return;
        }
    }
    rootStore.endOrderStore.setEndDateVal(key, val);
}

// 검색 시작일,종료일 초기화
export function fn_initDateVal(rootStore) {
    rootStore.endOrderStore.initEndDateVal();
}


export function fn_initEndOrderAll(rootStore) {
    // 검색 레이어 초기화
    fn_initSearchView(rootStore);
    // 상세버튼 초기화
    fn_initDetailButtonView(rootStore);
    // 검색 키값 초기화
    fn_initSearchKey(rootStore);
    // 시작일 종료일 초기화
    fn_initDateVal(rootStore);
    // 검색 날짜버튼 초기화
    fn_initDateTerm(rootStore);
    // 검색 값 초기화
    fn_setSearchVal(rootStore, '');
}

// 다음페이지
export function fn_endOrderNextPage(rootStore) {
    rootStore.endOrderStore.nextEndOrderPage();
    // 화면 재조회
    fn_endOrderSearch(rootStore)
}

// 이전페이지지
export function fn_endOrderPrevPage(rootStore) {
    rootStore.endOrderStore.prevEndOrderPage();
    // 화면 재조회
    fn_endOrderSearch(rootStore)
}

// 검색
export function fn_endOrderSearch(rootStore, btn) {
    if (btn != undefined) {
        analyticeEvent("search", btn, rootStore.searchStore.getShopCd) //GA4
    }

    reload_end_order_list(rootStore);
    fn_initSearchView(rootStore);

}